// src/components/Cargando.jsx
// Spinner reutilizable — reemplaza todos los "Cargando..." planos
import React from "react";

export default function Cargando({ texto = "" }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "52px 20px", gap: 12 }}>
      <div className="dots-loader">
        <span /><span /><span />
      </div>
      {texto && <div style={{ fontSize: 12, color: "#94a3b8", fontWeight: 500 }}>{texto}</div>}
    </div>
  );
}
